import { List } from 'immutable';
import { PaymentStatus } from '../models/payment-status.enum';

export class PaymentStatusUtils {

  static readonly ERROR_CODES = List<PaymentStatus>([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR
  ]);

  static readonly NO_TOTAL_PAID_CODES = List<PaymentStatus>([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.REQUESTED,
    PaymentStatus.ERROR,
    PaymentStatus.REQUEST_REJECTED,
    PaymentStatus.RESENT_REQUEST,
    PaymentStatus.CANCELLED
  ]);

  static readonly NO_ESTIMATED_DUE_CODES = List<PaymentStatus>([
    PaymentStatus.READY,
    PaymentStatus.PENDING,
    PaymentStatus.INVOICED,
    PaymentStatus.FUNDED,
    PaymentStatus.PAY_SENT,
    PaymentStatus.PAID_DIRECT,
    PaymentStatus.CANCELLED
  ]);

  static isError(paymentStatus: PaymentStatus): boolean {
    return this.ERROR_CODES.contains(paymentStatus);
  }

  static isNoTotalPaid(paymentStatus: PaymentStatus): boolean {
    return this.NO_TOTAL_PAID_CODES.contains(paymentStatus);
  }

  static isNoEstimatedDue(paymentStatus: PaymentStatus): boolean {
    return this.NO_ESTIMATED_DUE_CODES.contains(paymentStatus);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/utils/payment-status-utils.ts